/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './fontawesome-icon.config';
export * from './icon-loader.service';
export * from './icon.component';
export * from './icon.model';
export * from './icon.module';
export * from './testing/icon-testing.module';
